import {post,get} from '@/ulits/http'

// 获取短信验证码

export function sendSmsCode(params) {
  return post('api/send-sms-code', params)
}

// 手机号登陆

export function login(params) {
  return post('api/auth/login-by-sms-code',params)
  // return post('api/auth/login-test',params)
}

// 获取用户详情

export function userInfo(params) {
  return get('api/user/detail',params)
}

// 密码登录

export function passwordLogin(params) {
  return post('api/auth/login-by-pass',params)
}

// 忘记密码

export function resetpassword(params) {
  return post('api/auth/reset-pass', params)
}

// 修改昵称

export function editName(params) {
  return post('api/update-nick-name',params)
}

//修改头像

export function editavatar(params) {
  return post('api/update-avatar',params)
}

//修改密码

export function editPassword(params) {
  return post('api/set-pass',params)
}